import { useSelector } from 'react-redux';
import {
  getDealFinderHasError,
  getDealFinderIsLoading,
  getDealFinderResultsData
} from '@state/slices/deal-finder-results/dealFinderResultsSelectors';
import { SkeletonElement, SkeletonVariant } from '@components/common/skeleton-loading';
import React from 'react';
import { PageTitle } from '@components/common/page-title';
import { useI18NextContext } from '@components/hooks';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';

export const Container = styled.div(({ theme }: ThemeProps) => ({
  marginTop: theme.custom.spacing.large,
  [mq.medium]: {
    marginTop: theme.custom.spacing.xxLarge,
    marginBottom: theme.custom.spacing.xxLarge
  }
}));

interface HeadingProps {
  isBeforeLoad?: boolean;
  destinationName?: string;
}

const Subtitle = styled.h3(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h3 as any),
  fontWeight: 'normal',
  margin: 0
}));

export const Heading = ({ isBeforeLoad, destinationName }: HeadingProps) => {
  const isLoading: boolean = useSelector(getDealFinderIsLoading);
  const hasError: boolean = useSelector(getDealFinderHasError);

  const {
    facets: {
      counts: { filtered }
    }
  } = useSelector(getDealFinderResultsData);
  const t: any = useI18NextContext();

  if (hasError) {
    return null;
  }

  if (isLoading || isBeforeLoad) {
    return (
      <Container>
        <SkeletonElement variant={SkeletonVariant.HEADING} width={'40%'} />
      </Container>
    );
  }

  const title = destinationName
    ? `${destinationName} ${t('common__label--hotels')}`
    : t('deal-finder__results--title', { count: filtered });

  const renderSubTitle = () =>
    isLoading ? (
      <SkeletonElement height={45} width={'50%'} />
    ) : (
      <Subtitle>{t('deal-finder__hotels-available--title', { count: filtered })}</Subtitle>
    );

  return (
    <Container id={'deal-finder-heading'}>
      <PageTitle heading={title} isGhosting={isLoading} boldHeading={!!destinationName} />
      {destinationName && renderSubTitle()}
    </Container>
  );
};
